import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import Card from "/react4xp/components/shared/Card/Card";
import Person from "/react4xp/components/shared/frontend/assets/person.svg";
import type { EmployeeCardProps } from "./EmployeeCard.d";

const ContactDetail = ({
  label,
  value,
  link,
}: {
  label: string;
  value: string;
  link?: string;
}) => (
  <div className="employee-card__contact-detail">
    <h3 className="text-h-medium">{label}</h3>
    {link ? <a href={link}>{value}</a> : <p>{value}</p>}
  </div>
);

export const EmployeeCardPart = (props: ComponentProps<PartData>) => {
  const {
    email,
    jobTitle,
    phone,
    businessPhone,
    room,
    department,
    imageSrc,
    address,
  } = (props.data as EmployeeCardProps) ?? {};

  const contactDetails = [
    {
      label: "E-post",
      value: email,
      link: email ? `mailto:${email}` : undefined,
    },
    { label: "Tittel", value: jobTitle },
    {
      label: "Mobiltelefon",
      value: phone,
      link: phone ? `tel:+${phone}` : undefined,
    },
    {
      label: "Telefon",
      value: businessPhone,
      link: businessPhone ? `tel:+${businessPhone}` : undefined,
    },
    {
      label: "Adresse",
      value: address,
    },
    {
      label: "Rom",
      value: room,
    },
    {
      label: "Enhet",
      value: department,
    },
  ].filter((detail) => detail.value);

  return (
    <Card>
      <Card.Image>
        {imageSrc ? <img src={imageSrc} alt={"ansattes bilde"} /> : <Person />}
      </Card.Image>
      <Card.Body>
        <h2 className="text-h-large">Kontakt</h2>
        {contactDetails.map((detail, index) => (
          <ContactDetail
            key={index}
            label={detail.label}
            value={detail.value as string}
            link={detail.link}
          />
        ))}
      </Card.Body>
    </Card>
  );
};

export default EmployeeCardPart;
